<template>
  <div class="row-full facebook_share">
    <div class="fb_text" v-if="getFbPoints !== 0 && !hasShare"><span>{{ getTranslations.home_fb_share_share_on }} {{ getFbPoints }} {{ getTranslations.home_fb_share_bonus_points }}</span></div>
    <div class="fb_button">
      <a style="cursor:pointer" class="fb_btn btn--icon" @click.prevent="shareRank()"><i class="icon-facebook"></i><span>{{ getTranslations.home_fb_share_share }}</span></a>
    </div>
    <span class="fb_error_msg" v-if="fb_error">{{ getTranslations.home_fb_share_this_fb_account }}</span>
  </div>
</template>

<script>
import FacebookMixin from '@/common/mixins/facebookIntegration';
import RoundUpMixin from '@/common/mixins/roundUp';
import { mapState, mapGetters, mapActions } from 'vuex';

export default {
  name: 'fb-share-rank',
  props: ['ranks', 'winners', 'updatePoints', 'type', 'day'],
  mixins: [FacebookMixin, RoundUpMixin],
  data() {
    return {
      action: 'RANK',
      hasShare: false,
      winner: {},
      redirectUrl: '',
      fb_error: false,
      points: '',
    };
  },
  created() {
    // eslint-disable-next-line
    this.redirectUrl = `${window.location.href}${this.getFbUrlSuffix()}${this.getLocale || localStorage.getItem('locale')}/${this.ranks.displayPercentage ? `${this.ranks.displayPercentage}/` : ''}`;
    // eslint-disable-next-line
    console.log('redirectUrl: ', this.redirectUrl);
    this.hasAlreadyShare().then((response) => {
      const today = this.$moment(new Date()).format('YYYY-MM-DD');
      if (response.data && response.data === today) {
        // eslint-disable-next-line
        console.log('has shared!!!');
        this.hasShare = true;
      } else {
        this.forceFbToScrapNewMetadata(this.redirectUrl, () => {
          // eslint-disable-next-line
          console.log('successful scrapping!');
        });
      }
    });
  },
  methods: {
    ...mapActions('profile', [
      'getLastSharedRankDate',
      'storeLastSharedRankDate',
      'giveContent',
    ]),
    getFbUrlSuffix() {
      switch (this.type) {
      case 'DAILY': return '/daily/';
      case 'WEEKLY': return '/week/';
      case 'MONTHLY': return '/month/';
      case 'GRAND': return '/grand/';
      default: return '';
      }
    },
    hasAlreadyShare() {
      return this.getLastSharedRankDate();
    },
    assignPoints() {
      this.giveContent({ action: 'RANK', points: this.getFbPoints }).then((response) => {
        if (response.data.responseEnum === 'OPERATION_SUCCESS') {
          this.hasShare = true;
          this.updatePoints();
        }
      });
    },
    showError() {
      this.fb_error = true;
    },
    shareRank() {
      this.fb_error = false;
      this.points = this.getFbPoints;
      this.share(
        this.userDetails.facebookId,
        this.userDetails.id,
        this.assignPoints,
        this.showError,
      );
    },
  },
  computed: {
    getFbPoints() {
      const userPoints = (this.userDetails.facebookId ? this.userDetails.dailyPointsEarned : this.userDetails.dailyPointsEarned + this.connectionPoints);
      return this.roundUpNumber(Math.floor(userPoints * 0.1));
    },
    ...mapState('profile', [
      'dailyPrizeForLeaderboard',
      'weeklyPrizeForLeaderboard',
      'monthlyPrizeForLeaderboard',
      'grandPrizeForLeaderboard',
    ]),
    ...mapState('common', [
      'userDetails',
      'connectionPoints',
    ]),
    ...mapGetters('i18n', [
      'getTranslations',
      'getLocale',
    ]),
  },
};
</script>



// WEBPACK FOOTER //
// src/components/home/prizesAndLeaderboards/FbShareRank.vue